import {
  loadSummary,
  initializeSummary,
  toggleSection,
  setPortfolioPnlUnit,
  setPortfolioPnlRange,
} from './features/summary/summary.ts';
import { applyVisitorIdFromUrl } from './features/brokerage/plaidApi.ts';
import {
  initializeBrokerage,
  connectBrokerage,
} from './features/brokerage/brokerage.ts';
import { checkConfig } from './config.ts';
import './utils/debugLogger.ts';

declare global {
  interface Window {
    loadSummary: typeof loadSummary;
    toggleSection: typeof toggleSection;
    setPortfolioPnlUnit: typeof setPortfolioPnlUnit;
    setPortfolioPnlRange: typeof setPortfolioPnlRange;
    connectBrokerage: typeof connectBrokerage;
  }
}

function initializeApp(): void {
  applyVisitorIdFromUrl();
  checkConfig();

  window.loadSummary = loadSummary;
  window.toggleSection = toggleSection;
  window.setPortfolioPnlUnit = setPortfolioPnlUnit;
  window.setPortfolioPnlRange = setPortfolioPnlRange;
  window.connectBrokerage = connectBrokerage;

  initializeSummary();
  void initializeBrokerage();
}

initializeApp();
